import { useForm, ListButton, SaveButton } from "@refinedev/antd";
import {
  Collapse,
  Flex,
  Form,
  Input,
  Typography,
  Button,
  message,
} from "antd";
import { useTranslate } from "@refinedev/core";
import { CheckOutlined, LeftOutlined } from "@ant-design/icons";
import { PhoneNumberInput } from "@/components/phone-number-input";

export const StoresCreate = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps, onFinish } = useForm<any>({
    warnWhenUnsavedChanges: true,
  });

  const collapseItems = [
    {
      key: "technical",
      label: <span style={{ fontWeight: 600 }}>Técnico</span>,
      styles: { header: { height: 40, alignItems: "center" } },
      children: (
        <Form
          {...formProps}
          layout="horizontal"
          labelCol={{ span: 9 }}
          wrapperCol={{ span: 15 }}
          style={{ maxWidth: 640 }}
          colon
        >
          <Form.Item label="Código" name="seller_code">
            <Input disabled placeholder="storecode" />
          </Form.Item>
          <Form.Item label="Nombre del store" name="name" rules={[{ required: true }]}>
            <Input placeholder="nombreempresa" />
          </Form.Item>
          <Form.Item
            label="URL del store"
            name="url"
            rules={[{ required: true }]}
            extra="Para usar tu propia URL, editá el registro CNAME donde WWW apunta a host.xcons.com.ar en tu proveedor de DNS. Cambiá la URL solo una vez para evitar problemas de SEO."
          >
            <Input placeholder="nombreempresa.xcons.com.ar" />
          </Form.Item>
          <Form.Item
            label="SSL CNAME del store"
            name="sslCname"
            extra="Agregá este registro CNAME en tu proveedor de DNS para proteger tu Store con SSL"
          >
            <Input disabled />
          </Form.Item>
        </Form>
      ),
    },
    {
      key: "company",
      label: <span style={{ fontWeight: 600 }}>Información de empresa</span>,
      styles: { header: { height: 40, alignItems: "center" } },
      children: (
        <Form
          {...formProps}
          layout="horizontal"
          labelCol={{ span: 9 }}
          wrapperCol={{ span: 15 }}
          style={{ maxWidth: 640 }}
          colon
        >
          <Form.Item
            label="Nombre de empresa"
            name="legalName"
            rules={[{ required: true }]}
          >
            <Input placeholder="Nombre o razón social de tu empresa" />
          </Form.Item>
          <Form.Item label="CUIT / Tax ID" name="tax" rules={[{ required: true }]}>
            <Input placeholder="CUIT o número de identificación fiscal" />
          </Form.Item>
          <Form.Item
            label="WhatsApp de ventas"
            name="whatsapp"
            rules={[{ required: true }]}
            extra="Se usa como contacto público por defecto del Store"
          >
            <PhoneNumberInput placeholder="(Cód. Área) - Teléfono" />
          </Form.Item>
          <Form.Item
            label="Teléfono de ventas"
            name="phone"
            rules={[{ required: true }]}
            extra="Se usa como contacto público por defecto del Store"
          >
            <PhoneNumberInput placeholder="(Cód. Área) - Teléfono" />
          </Form.Item>
          <Form.Item
            label="Email de ventas"
            name="email"
            rules={[{ required: true, type: "email" }]}
            extra="Se usa como contacto público por defecto del Store y como reply-to en todos los emails de ventas enviados por el store"
          >
            <Input placeholder="ventas@nombreempresa.com" />
          </Form.Item>
          <Form.Item
            label="Email de facturación"
            name="billingEmail"
            extra="Las facturas de XCONS se enviarán a este email"
          >
            <Input placeholder="facturacion@nombreempresa.com" />
          </Form.Item>
          <Form.Item
            label="Email del webmaster"
            name="webmasterEmail"
            rules={[{ required: true, type: "email" }]}
            extra="Generalmente el CTO o dueño de la empresa. Esta cuenta tendrá todos los permisos de administrador del Store, sus operadores, etc."
          >
            <Input placeholder="propietario@nombreempresa.com" />
          </Form.Item>
        </Form>
      ),
    },
  ];

  return (
    <Flex vertical style={{ height: "100%", minHeight: 0 }}>
      <Flex align="center" style={{ marginBottom: 24, flexShrink: 0 }}>
        <ListButton hideText icon={<LeftOutlined />} />
        <Typography.Title level={3} style={{ marginBottom: 0, marginLeft: 10 }}>
          Crear nuevo store
        </Typography.Title>
      </Flex>

      <div style={{ flex: 1, overflowY: "auto" }}>
        <Collapse defaultActiveKey={["technical", "company"]} items={collapseItems} />
      </div>

      <div style={{ paddingTop: 32, paddingBottom: 16, flexShrink: 0 }}>
        <Flex justify="space-between">
          <ListButton icon={<LeftOutlined />}>
            {t("buttons.back", "Volver")}
          </ListButton>
          <SaveButton
            {...saveButtonProps}
            icon={<CheckOutlined />}
            iconPosition="end"
          >
            {t("buttons.saveCreate", "Crear y guardar")}
          </SaveButton>
        </Flex>
      </div>
    </Flex>
  );
};
